<template>
	<v-dialog v-model="localIsVisible" persistent max-width="910" >
		<v-card class="relative">
			<div class="tw-px-14 tw-py-14">
				<close-icon
					class="design-scale-chart-close cursor-pointer"
					@click="localIsVisible = !localIsVisible"
				/>
				<div style="height: 450px">
					<canvas id="chart"></canvas>
				</div>
			</div>
			<div class="design-scale-chart-footer tw-px-14 tw-py-5">
				<span class="text-info design-scale-chart-caption caption-secondary tw-mr-10">
					Sueldo Actual
				</span>
				<span class="text-info design-scale-chart-caption caption-primary tw-mr-10">
					Sueldo Ideal
				</span>
				<span class="text-info design-scale-chart-caption caption-average">
					Valoración
				</span>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
import CloseIcon from '@/modules/shared/components/icons/close-icon';
import Chart from 'chart.js';

function data() {
	return {
		localIsVisible: false,
		$chartInstance: undefined,
	};
}

function generateChart() {
	const canvas = document.getElementById('chart');
	if (!canvas || !this.data || !this.data.labels || this.data.labels.length === 0) return;
	if (this.$chartInstance) {
		this.$chartInstance.destroy();
	}
	const datasets = [
		{
			type: 'line',
			label: 'Sueldo Ideal',
			data: this.data.idealSalaries,
			borderColor: '#55ac4b',
			backgroundColor: 'rgba(85, 172, 75, 0.1)',
			fill: '+1',
			pointRadius: 6,
			pointHoverRadius: 8,
			pointBackgroundColor: '#55ac4b',
			pointBorderColor: '#fff',
			pointBorderWidth: 2,
			borderWidth: 3,
			order: 1,
		},
		{
			type: 'line',
			label: 'Sueldo Actual',
			data: this.data.currentSalaries,
			borderColor: '#f09c2b',
			backgroundColor: 'rgba(240, 156, 43, 0.1)',
			fill: false,
			pointRadius: 6,
			pointHoverRadius: 8,
			pointBackgroundColor: '#f09c2b',
			pointBorderColor: '#fff',
			pointBorderWidth: 2,
			borderWidth: 3,
			order: 2,
		},
		{
			type: 'bar',
			label: 'Valoración',
			data: this.data.averages,
			backgroundColor: 'rgba(84, 90, 84, 0.15)',
			borderColor: 'rgba(84, 90, 84, 0.4)',
			borderWidth: 1,
			yAxisID: 'y-right',
			order: 3,
		},
	];
	this.$chartInstance = new Chart(canvas, {
		type: 'bar',
		data: {
			labels: this.data.labels,
			datasets,
		},
		options: {
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				position: 'top',
				labels: {
					fontSize: 12,
					fontStyle: 'bold',
					padding: 20,
					usePointStyle: true,
				},
			},
			layout: {
				padding: {
					top: 10,
				},
			},
			scales: {
				xAxes: [
					{
						gridLines: {
							display: false,
						},
						offset: true,
					},
				],
				yAxes: [
					{
						position: 'left',
						ticks: {
							beginAtZero: true,
							callback(value) {
								return `$${value.toLocaleString()}`;
							},
						},
						gridLines: {
							color: 'rgba(0, 0, 0, 0.06)',
						},
						scaleLabel: {
							display: true,
							labelString: 'Salario',
							fontSize: 12,
							fontStyle: 'bold',
						},
					},
					{
						id: 'y-right',
						position: 'right',
						ticks: {
							beginAtZero: true,
							max: 1000,
							callback(value) {
								return value;
							},
						},
						gridLines: {
							drawOnChartArea: false,
						},
						scaleLabel: {
							display: true,
							labelString: 'Valoración',
							fontSize: 12,
							fontStyle: 'bold',
						},
					},
				],
			},
			tooltips: {
				mode: 'index',
				intersect: false,
				callbacks: {
					label(tooltipItem) {
						const dsLabel = datasets[tooltipItem.datasetIndex].label;
						const value = tooltipItem.yLabel;
						if (dsLabel === 'Valoración') {
							return ` ${dsLabel}: ${value} pts`;
						}
						return ` ${dsLabel}: $${Number(value).toLocaleString()}`;
					},
				},
			},
		},
	});
}

export default {
	name: 'DesignScaleChartModal',
	components: { CloseIcon },
	props: ['isVisible', 'data'],
	model: {
		prop: 'isVisible',
		event: 'isVisibleChange',
	},
	data,
	methods: {
		generateChart,
	},
	watch: {
		isVisible(newValue) {
			this.localIsVisible = newValue;
			if (newValue) {
				this.$nextTick(() => this.generateChart());
			}
		},
		localIsVisible(newValue) {
			this.$emit('isVisibleChange', newValue);
		},
		data() {
			if (this.localIsVisible) {
				this.$nextTick(() => this.generateChart());
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.design-scale-chart-close {
	position: absolute;
	right: 20px;
	top: 20px;
	z-index: 1;
}

.design-scale-chart-footer {
	background-color: #fafafa;
}

.design-scale-chart-caption {
	display: inline-flex;
	align-items: center;

	&:before {
		content: '';
		width: 20px;
		height: 20px;
		display: inline-block;
		margin-right: 10px;
		border-radius: 50%;
	}

	&.caption-primary {
		&:before {
			background-color: var(--app-color-primary);
		}
	}

	&.caption-secondary {
		&:before {
			background-color: var(--app-color-secondary);
		}
	}

	&.caption-average {
		&:before {
			background-color: rgba(84, 90, 84, 0.4);
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/process/design-scale/design-scale-chart-modal.vue